import { render } from "./SectionComents.vue?vue&type=template&id=025d50d4&scoped=true"
import script from "./SectionComents.vue?vue&type=script&lang=js"
export * from "./SectionComents.vue?vue&type=script&lang=js"

import "./SectionComents.vue?vue&type=style&index=0&id=025d50d4&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-025d50d4"]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QTree from 'quasar/src/components/tree/QTree.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QImg,QTree,QIcon,QCard,QInnerLoading});
